import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {
  Card,
  Typography,
  IconButton,
  Icon
} from '@material-ui/core';
import {deleteAdditionalFeaturesApi} from 'api/subscription';


const FeaturesList = ({setFeature}) => {
  const dispatch = useDispatch();
  const { additionalFeatures } = useSelector((state) => state.subscription);

  return (
    <div>
      {additionalFeatures.map((element) => (
        <Card
          className="p-4 m-4 flex justify-between items-center"
          key={element._id}
        >
          <Typography variant="h6" className="text-brand">{element.label}</Typography>
          <div>
            <IconButton
              className="mr-2"
              title="Edit"
              onClick={() => setFeature(element)}
            >
              <Icon className="text-gray">edit</Icon>
            </IconButton>
            <IconButton
              className="mr-2"
              title="Delete"
              onClick={() => deleteAdditionalFeaturesApi({dispatch, id: element._id})}
            >
              <Icon className="text-gray">delete</Icon>
            </IconButton>
          </div>

        </Card>
      ))}
    </div>
  );
};

export default FeaturesList;
